module.exports = __webpack_public_path__ + "media/images/education-f50f9ba0fd98388797471ed451695132.svg";